<template>
    <transition name="slide">
        <div :class="['aside-menu', { 'collapsed': isOpenAside, 'dark-mode': isDarkMode }]">
            <div class="mode-settings pb-3">
                <label for="mode">Mode</label>
                <label class="switch-mode">
                    <input id="mode" name="mode" type="checkbox" v-model="isDarkMode" @change="toggleDarkMode">
                    <span class="slider"></span>
                </label>
            </div>
			<nav class="nav flex-column">
				<ul>
					<li v-for="module in modules" :key="module.id">
						<!-- Main module with submodules -->
						<div v-if="module.sub_modules && module.sub_modules.length">
							<a href="#" @click.prevent="toggleMainMenu(module.id)">
								<li :class="{ open: openMainMenus.includes(module.id), open: isModuleActive(module) }">
									<font-awesome-icon :icon="module.icon" class="me-3" />
									{{ module.name }}
									<small>
										<font-awesome-icon
											:icon="openMainMenus.includes(module.id) ? 'chevron-up' : 'chevron-down'"
											:class="['rotate-chevron', { open: openMainMenus.includes(module.id) }]"
											class="float-end ms-auto"
										/>
									</small>
								</li>
							</a>
							<transition name="submenu" mode="out-in">
								<ul class="sub-menu" v-if="openMainMenus.includes(module.id)">
									<li v-for="sub in module.sub_modules" :key="sub.id">
										<router-link :to="sub.route" exact-active-class="active">
											<li :class="{ active: $route.path.startsWith(sub.route) }">
												<font-awesome-icon :icon="sub.icon" class="mx-3" />
												{{ sub.name }}
										<span v-if="notificationCount(sub)" class="aside-unread-badge">
											{{ formatNotificationCount(notificationCount(sub)) }}
										</span>
											</li>
										</router-link>
									</li>
								</ul>
							</transition>
						</div>
						<!-- Main module without submodules -->
						<div v-else>
							<router-link :to="module.route" exact-active-class="active" v-slot="{ isActive }" @click="toggleCloseMainMenu">
								<li :class="{ active: isActive && routerLinkActive }">
									<font-awesome-icon :icon="module.icon" class="me-3" />
									{{ module.name }}
									<span v-if="notificationCount(module)" class="aside-unread-badge">
										{{ formatNotificationCount(notificationCount(module)) }}
									</span>
								</li>
							</router-link>
						</div>
					</li>
				</ul>
			</nav>
        </div>
    </transition>
</template>

<script src="./AsideScript.vue"/>
